// Generated by purs version 0.15.15
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Ouroboros_Models_Brands_BillingPeriod from "../Ouroboros.Models.Brands.BillingPeriod/index.js";
import * as Ouroboros_Models_Brands_ErrorMessageText from "../Ouroboros.Models.Brands.ErrorMessageText/index.js";
import * as Ouroboros_Models_Brands_IsoTimestamp from "../Ouroboros.Models.Brands.IsoTimestamp/index.js";
import * as Ouroboros_Models_Brands_PlanTier from "../Ouroboros.Models.Brands.PlanTier/index.js";
import * as Ouroboros_Models_Brands_SeatCount from "../Ouroboros.Models.Brands.SeatCount/index.js";
import * as Ouroboros_Services_FFI_DateTime from "../Ouroboros.Services.FFI.DateTime/index.js";
import * as Ouroboros_Services_FFI_StubAdminPlan from "../Ouroboros.Services.FFI.StubAdminPlan/index.js";
import * as Ouroboros_Services_FFI_TaskEither from "../Ouroboros.Services.FFI.TaskEither/index.js";
var createStubAdminPlanClient = {
    getPlan: /* #__PURE__ */ (function () {
        var $1 = Ouroboros_Services_FFI_StubAdminPlan.getAdminPlanStubMode(Data_Unit.unit) === "error";
        if ($1) {
            return Ouroboros_Services_FFI_TaskEither.left({
                type: "NetworkError",
                message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText(Ouroboros_Services_FFI_StubAdminPlan.getAdminPlanStubErrorMessage(Data_Unit.unit)),
                statusCode: Data_Maybe.Nothing.value
            });
        };
        return Ouroboros_Services_FFI_TaskEither.right({
            seatLimit: Ouroboros_Models_Brands_SeatCount.makeSeatCount(10.0),
            tier: Ouroboros_Models_Brands_PlanTier.makePlanTier("Standard"),
            billingPeriod: Ouroboros_Models_Brands_BillingPeriod.makeBillingPeriod("Monthly"),
            activeAt: Ouroboros_Models_Brands_IsoTimestamp.makeIsoTimestamp(Ouroboros_Services_FFI_DateTime.nowIso(Data_Unit.unit)),
            endAt: Data_Maybe.Nothing.value,
            billingHistory: [  ]
        });
    })()
};
export {
    createStubAdminPlanClient
};
//# sourceMappingURL=index.js.map
